<template>
  <div class="setting">
    <el-page-header @back="$router.back(-1)" content="法律法规">
    </el-page-header>
    <br />
    <div class="scroll">
      <el-card class="box-card articleDetail" v-if="detail">
        <h2>{{detail.name}}</h2>
        <p class="updateTime">（{{detail.revisionTime}}）</p>
      <div v-html="detail.content"></div>
      </el-card>
      <el-backtop :bottom="50"></el-backtop>
    </div>
  </div>
</template>

<script>
  // import api from '@/api/index';
  export default {
    data() {
      return {
        detail: null,
        key: 0,
        id: this.$route.query.id || '',
        // kw: this.$route.query.kw || '',
        content: this.$route.query.content || '',
      }
    },
    beforeCreate() {},
    mounted() {
      if (this.content) {
        let res = window.find(this.content);
      }
    },
    created() {
      this.getDeatil();
    },
    updated() {
      if (this.content && this.detail) {
        let res = window.find(this.content);
      }
    },
    watch:{
        // 在原窗口打开时
        detail: {
          handler:function(val, oldVal){
            this.$nextTick(function(){  //页面加载完成后执行
              if(this.content){
                window.find(this.content, true, true);
              }
            })
          },
          deep: true
        }
      },
    computed: {},

    methods: {
      async getDeatil() {

        this.$axios.get(this.$serviceAPI.findOneRegulationsList, {
          _id: this.id,
        }).then(res => {
          this.detail = res.data.data;
          this.key += 1;
          // setTimeout(()=>{
          //   if(this.content && this.detail){
          //     window.find(this.content, true, true);
          //   }
          // }, 500)
        })
      }
    },
    find() {},


  }
</script>

<style scoped="scoped">
  p{
    font-size: 17px;
  }
  .setting {
    padding: 15px 15px 15px;
    box-sizing: border-box;
  }

  .articleDetail h2,
  .articleDetail h3 {
    text-align: center;
    font-size: 25px;
  }

  .articleDetail h3 {
    margin: 30px 0;
    font-size: 21px;
  }

  .articleDetail .updateTime {
    text-align: center;
    color: #888;
    margin-bottom: 30px;
    font-family: "隶书";
  }

  .articleDetail section .h4 {
    font-weight: bold;
    margin-right: 15px;
  }

  .articleDetail section p {
    line-height: 30px;
    text-indent: 2em;
  }

 /* .scroll {
    height: calc(100vh - 187px);
    overflow-y: scroll;
  } */
</style>



// WEBPACK FOOTER //
// src/components/subPage/Detail.vue